var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"buybox-row"},[_c('label',{staticClass:"buybox-row__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }